// App.js
import React from 'react';
import { Router } from './routes';

// Theme + context
import ThemeProvider from './Components/CoreApp/theme';
import { DarkModeProvider, useDarkMode } from './Components/CoreApp/context/DarkModeContext';

// Core components
import ScrollToTop from './Components/CoreApp/components/ScrollToTop';
import { BaseOptionChartStyle } from './Components/CoreApp/components/chart/BaseOptionChart';

// Internal wrapper to pass darkMode to ThemeProvider
function AppWithTheme() {
  const { darkMode } = useDarkMode();

  return (
    <ThemeProvider darkMode={darkMode}>
      <ScrollToTop />
      <BaseOptionChartStyle />
      <Router />
    </ThemeProvider>
  );
}

// Main export with context
export default function App() {
  return (
    <DarkModeProvider>
      <AppWithTheme />
    </DarkModeProvider>
  );
}
